import { useAppStore, Screen } from '../store/useAppStore';
import { Icon } from './Icon';
import { telegram } from '../lib/telegram';

const GAMES: { id: Screen; label: string; icon: 'dice' | 'refresh' | 'bolt' | 'rocket' }[] = [
  { id: 'dice', label: 'Dice', icon: 'dice' },
  { id: 'crash', label: 'Ракетка', icon: 'rocket' },
  { id: 'roulette', label: 'Рулетка', icon: 'refresh' },
  { id: 'slots', label: 'Слоты', icon: 'bolt' },
];

export function GameTabs() {
  const screen = useAppStore((s) => s.screen);
  const setScreen = useAppStore((s) => s.setScreen);

  return (
    <div className="game-tabs">
      {GAMES.map((g) => (
        <button
          key={g.id}
          className={`game-tab ${screen === g.id ? 'active' : ''}`}
          onClick={() => {
            if (screen !== g.id) telegram.haptic('light');
            setScreen(g.id);
          }}
        >
          <Icon name={g.icon} size={16} />
          {g.label}
        </button>
      ))}
    </div>
  );
}
